<template>
  <div class="px-3 main-wrapper">
    <div class="d-flex justify-content-between align-items-center w-100 gap-2 my-4">
      <div class="flex-fill">
        <ProviderSelectDialog
          :providers="liveProviders"
          :selectedProvider="selectedProvider"
        />
      </div>
      <div class="flex-fill">
        <GameSearchDialog :games="games" />
      </div>
    </div>
    <div>
      <div>
        <!-- 🔹 Loading State -->
        <div
          v-if="isGamesLoading"
          class="game-list grid grid-cols-4"
        >
          <GameCardSkeleton
            v-for="n in 16"
            :key="n"
          />
        </div>

        <!-- 🔹 Empty State -->
        <div
          v-else-if="!games.length"
          class="flex flex-col items-center justify-center py-12 text-gray-400"
        >
          <van-empty description="No games available" />
        </div>

        <!-- 🔹 Game List -->
        <div
          v-else
          class="game-list grid grid-cols-4"
        >
          <GameCard
            v-for="(game, index) in newGames.length > 0 ? newGames : games"
            :key="index"
            @click="gameInit(game)"
            :game="game"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import GameCard from "@/components/GameCard.vue";
import GameCardSkeleton from "@/components/GameCardSkeleton.vue";
import GameSearchDialog from "@/components/GameSearchDialog.vue";
import ProviderSelectDialog from "@/components/ProviderSelectDialog.vue";

export default {
  components: {
    GameCard,
    GameCardSkeleton,
    ProviderSelectDialog,
    GameSearchDialog
  },
  data() {
    return {
      games: [],
      isGamesLoading: false,

      name: null,
      newGames: [],
      limitText: "",
      desiredGame: null,

      selectedProvider: this.$route.query.provider || "",
    };
  },
  computed: {
    ...mapState('providers', [
      'liveProviders',
      'isProvidersFetching',
    ]),
  },
  methods: {
    ...mapActions(['fetchUser']),
    ...mapActions('providers', ['fetchActiveProviders']),

    async fetchGames() {
      this.isGamesLoading = true;
      try {
        const { data } = await axios.get('/games', {
          params: {
            type: 'lc',
            provider: this.$route.query.provider,
          },
        });
        this.games = data;

      } catch (error) {
        console.log(error);
      } finally {
        this.isGamesLoading = false;
      }
    },

    async gameInit(game) {
      try {
        this.$store.commit("setLoading", true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        let providerID = this.$route.query.provider;
        const res = await axios.get("/games/url",
          {
            params: {
              gameID: game.gameID,
              provider: providerID,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        window.open(res.data.data.gameUrl, "_self");

        this.$store.commit("setLoading", false);
      } catch (error) {
        this.$store.commit("setLoading", false);
      }
    },
  },
  watch: {
    "$route.query.provider": {
      immediate: true,
      handler(newProvider) {
        this.selectedProvider = newProvider || "";
        this.$store.commit('setLoading', true);
        this.fetchGames();
        this.$store.commit('setLoading', false);
      },
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchActiveProviders();
    await this.fetchGames();
    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped></style>
